import React, { useState, useRef, useEffect } from 'react';
import { MdEdit, MdPrint, MdClose } from 'react-icons/md';
import { useSearchParams } from 'react-router-dom';
import { useLanguage } from '../StoreContext/LanguageContext';
import { toast } from 'react-toastify';
import apiService from '../config';

const LandAcquisitionCerti = () => {
    const [dataLoading, setDataLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchParams] = useSearchParams();

    // Get parameters from URL first
    const urlProjectId = searchParams.get('projectId');
    const urlProposalId = searchParams.get('proposalId');

    const [projectId, setProjectId] = useState(urlProjectId);
    const [proposalId, setProposalId] = useState(urlProposalId);
    const [projectName, setProjectName] = useState(null);

    const certificateContentRef = useRef(null);
    const [isEditing, setIsEditing] = useState(false);
    const [loading, setLoading] = useState(false);
    const { language, translations } = useLanguage();

    const [usersLAO, setusersLAO] = useState([]);
    const [landData, setLandData] = useState([]);
    const [kjpData, setKjpData] = useState([]); 

    const laoName = usersLAO?.[0]?.full_name || '----------------';
    const laoDesi = usersLAO?.[0]?.designation || 'भूसंपादन अधिकारी';

    // Initialize form data
    const [formData, setFormData] = useState({
        acquisition_proposal_no: '',
        office_name: '',
        section_11_branch_name: '',
        address: '',
        section_11_email: '',
        section_11_mobile_no: '',
        project_name: '',
        section_11_address: "",
        section_11_office_name: "",
        section_11_bhusampadan_no: "",
        certificate_no: '',
        certificate_date: '',
        certificate_default_content: ''
    });

    const ROLES = {
        COLLECTOR: 1,
        LAO: 3,
        SAMANVAY: 6,
        PROJECT_INCHARGE: 18,
        DATA_ENTRY: 14
    };

    const userData = JSON.parse(localStorage.getItem('userData'));
    const userRole = parseInt(userData?.data?.user_role || userData?.user_role, 10);

    // Get Project ID
    useEffect(() => {
        const getProjectInfo = () => {
            if (urlProjectId) return { id: urlProjectId, name: null };
            
            const currentProjectData = localStorage.getItem('currentProjectData');
            if (currentProjectData) {
                try {
                    const projectData = JSON.parse(currentProjectData);
                    return { id: projectData.project_id || projectData.id, name: projectData.project_name || projectData.name };
                } catch (e) { console.error(e); }
            }
            
            const selectedProject = localStorage.getItem('selectedProject');
            if (selectedProject) {
                try {
                    const project = JSON.parse(selectedProject);
                    return { id: project.project_id || project.id, name: project.project_name || project.name };
                } catch (e) { console.error(e); }
            }
            return { id: null, name: null };
        };

        const projectInfo = getProjectInfo();
        setProjectId(projectInfo.id);
        setProjectName(projectInfo.name);
    }, [urlProjectId]);

    // Get Proposal ID
    useEffect(() => {
        const getProposalInfo = () => {
            if (urlProposalId) return { proposalId: urlProposalId };
            
            const userData = localStorage.getItem('userData');
            if (userData) {
                try {
                    const currentProposal = JSON.parse(userData);
                    return {
                        proposalId: currentProposal?.data?.default_proposal || currentProposal?.data?.proposal_id ||
                                    currentProposal?.default_proposal || currentProposal?.proposal_id || null
                    };
                } catch (e) { console.error(e); }
            }
            return { proposalId: null };
        };

        const proposalInfo = getProposalInfo();
        setProposalId(proposalInfo.proposalId);
    }, [urlProposalId]);

    const formatDate = (dateString) => {
        if (!dateString) return '------------';
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        return dateString.split('T')[0];
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // Construct the default string format based on the requested template
    const generateDefaultContent = (bhusampadanNo, certDate, proposalNo, projName) => {
        const p1 = bhusampadanNo || '------------';
        const p2 = certDate ? formatDate(certDate) : '------------';
        const p3 = proposalNo || '------------';
        const p4 = projName || '------------';
        return `प्रमाणित करण्यात येते की, भुसंपादन प्रकरण क्रमांक ${p1} या मधील दिनांक ${p2} रोजीच्या अंतिम निवाडयानुसार ${p3} यांची खालील वर्णनाची जमीन/जागा ${p4} यांचे बुडीत क्षेत्राकरीता संपादीत करण्यात आली आहे.`;
    };

    // 1. Fetch Proposal Data
    const fetchProposalData = async () => {
        const project = JSON.parse(localStorage.getItem("selectedProject") || "{}");
        const response = await apiService.getProposalById(projectId, proposalId);
        if (response && response.data) {
            const proposalData = response.data;
            setFormData(prev => ({
                ...prev,
                section_11_branch_name: proposalData.section_11_branch_name || prev.section_11_branch_name,
                section_11_email: proposalData.section_11_email || prev.section_11_email,
                section_11_mobile_no: proposalData.section_11_mobile_no || prev.section_11_mobile_no,
                acquisition_proposal_no: proposalData.acquisition_proposal_no || prev.acquisition_proposal_no,
                section_11_address: proposalData.section_11_address || prev.section_11_address,
                section_11_bhusampadan_no: proposalData.section_11_bhusampadan_no || prev.section_11_bhusampadan_no,
                section_11_office_name: proposalData.section_11_office_name || prev.section_11_office_name,
                office_name: proposalData.office_name || prev.office_name,
                address: proposalData.address || prev.address,
                project_name: project.project_name || proposalData.project_name || prev.project_name,
            }));
        }
    };

    // 2. Fetch LAO
    const fetchusersLAO = async () => {
        const response = await apiService.getAssignLAO(3, projectId, proposalId);
        if (response.status === 200 && response.data) {
            setusersLAO(Array.isArray(response.data) ? response.data : []);
        }
    };

    // 3. Fetch Owner/Land Data
    const fetchOwnerData = async () => {
        const response = await apiService.getAllOwner(null, null, null, projectId, proposalId);
        if (response && response.data && response.data.length > 0) {
            const transformedLandData = response.data.map((owner, index) => ({
                id: owner.id || owner.ownerId || owner.owner_id || Date.now() + index, 
                village_name: owner.village_name || owner.villageName || '',
                gat_no: owner.gat_no || owner.gatNo || owner.survey_no || '',
                irrigable_area: owner.irrigable_area || owner.cultivableArea || '0.00',
                non_irrigable_area: owner.non_irrigable_area || owner.barrenArea || '0.00',
                total_area: owner.total_area || owner.totalArea || 
                    ((parseFloat(owner.irrigable_area || owner.cultivableArea || 0) + 
                    parseFloat(owner.non_irrigable_area || owner.barrenArea || 0)).toFixed(2))
            }));
            setLandData(transformedLandData);
        }
    };

    // 4. Fetch KJPTabapavti API to get the 3 required columns
    const fetchKJPData = async () => {
        const response = await apiService.getKJPTabapavti(projectId, proposalId);
        const dataArray = Array.isArray(response?.data) ? response.data : (Array.isArray(response) ? response : []);
        setKjpData(dataArray);

        if (dataArray.length > 0) {
            const firstRecord = dataArray[0];
            setFormData(prev => ({
                ...prev,
                certificate_no: firstRecord.certificate_no || prev.certificate_no,
                certificate_date: firstRecord.certificate_date || prev.certificate_date,
                certificate_default_content: firstRecord.certificate_default_content || prev.certificate_default_content
            }));
        }
    };

    const fetchAllData = async () => {
        if (!projectId && !proposalId) return;
        try {
            setDataLoading(true);
            setError(null);
            const promises = [fetchOwnerData()];
            if (projectId && proposalId) {
                promises.push(fetchProposalData(), fetchusersLAO(), fetchKJPData());
            }
            await Promise.all(promises);
        } catch (error) {
            setError(`Error loading data: ${error.message}`);
        } finally {
            setDataLoading(false);
        }
    };

    useEffect(() => {
        if (projectId && proposalId) {
            fetchAllData();
        }
    }, [projectId, proposalId]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!proposalId) {
            toast.error('❌ No proposal ID found for update.');
            return;
        }

        try {
            setLoading(true);
            
            const ownersToUpdate = kjpData.length > 0 ? kjpData : landData.map(l => ({ owner_id: l.id }));

            if (ownersToUpdate.length === 0) {
                 toast.warn('कोणताही मालक डेटा आढळला नाही. कृपया मालक जोडा.');
                 setLoading(false);
                 return;
            }

            const promises = ownersToUpdate.map(owner => {
                const payload = {
                    project_id: projectId,
                    proposal_id: proposalId,
                    owner_id: owner.owner_id || owner.land_owner_id || owner.id,
                    certificate_no: formData.certificate_no,
                    certificate_date: formData.certificate_date,
                    certificate_default_content: formData.certificate_default_content || generateDefaultContent(formData.section_11_bhusampadan_no, formData.certificate_date, formData.acquisition_proposal_no, formData.project_name)
                };
                return apiService.postAddUpdateKJPTabapavti(payload);
            });

            await Promise.all(promises);
            
            toast.success('✅ Land Acquisition Certificate Updated Successfully');
            setIsEditing(false);
            await fetchAllData();
        } catch (error) {
            console.error('Error saving:', error);
            toast.error('❌ Error while updating certificate.');
        } finally {
            setLoading(false);
        }
    };

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        if (!printWindow) {
            toast.error('कृपया पॉपअपसना परवानगी द्या');
            return;
        }

        const content = certificateContentRef.current.innerHTML;
        const printHTML = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8">
          <style>
            @page {
              size: A4 portrait;
              margin: 1.5cm;
            }
            * { box-sizing: border-box; }
            body {
              font-family: 'DVOT-Surekh', 'Mangal', serif;
              font-size: 14px;
              line-height: 1.5;
              color: black;
              background: white;
            }
            .contact-file { font-size: 12px; margin-bottom: 15px; margin-top: 15px; }
            .contact-file .top { display: flex; justify-content: space-between; font-weight: bold; }
            .contact-file .bottom { display: flex; justify-content: space-between; font-weight: bold; border-top: 2px solid black; padding-top: 3px; margin-top: 3px; }
            table { width: 100%; border-collapse: collapse; margin: 1rem 0; }
            td, th { border: 2px solid black; padding: 8px; text-align: center; font-size: 12px; vertical-align: middle; }
            .signature-section { display: flex; justify-content: space-between; margin-top: 60px; }
            .font-bold { font-weight: bold; }
            .text-center { text-align: center; }
            .underline { text-decoration: underline; }
            .mb-4 { margin-bottom: 1rem; }
            @media print { body { -webkit-print-color-adjust: exact; } }
          </style>
        </head>
        <body>
          <div class="print-container">
            ${content}
          </div>
          <script>
            window.onload = function() { window.focus(); window.print(); };
          </script>
        </body>
        </html>`;

        printWindow.document.write(printHTML);
        printWindow.document.close();
    };

    const groupedLandData = landData.reduce((acc, curr) => {
        const village = curr.village_name || '-';
        if (!acc[village]) {
            acc[village] = [];
        }
        acc[village].push(curr);
        return acc;
    }, {});

    if (dataLoading) {
        return (
            <div className="container mx-auto p-6 bg-gray-50 min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-500 border-t-transparent"></div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container mx-auto p-6 bg-gray-50 min-h-screen text-center">
                <div className="text-red-500 text-xl mb-4">⚠️</div>
                <p className="text-red-600 mb-4">{error}</p>
                <button onClick={fetchAllData} className="px-6 py-2 bg-blue-600 text-white rounded-lg">पुन्हा प्रयत्न करा</button>
            </div>
        );
    }

    // Prepare default string if user hasn't explicitly set it yet
    const displayParagraph = formData.certificate_default_content || 
        generateDefaultContent(formData.section_11_bhusampadan_no, formData.certificate_date, formData.acquisition_proposal_no, formData.project_name);

    return (
        <div className="container mx-auto p-6 bg-gray-50 min-h-screen">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                
                {/* Action Buttons Header */}
                <div className="p-6 border-b border-gray-200">
                    <div className="flex flex-wrap gap-4 justify-start">
                        {(userRole === ROLES.LAO || userRole === ROLES.DATA_ENTRY) && (
                            <button
                                onClick={() => setIsEditing(true)}
                                className="flex items-center space-x-2 px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-all shadow-md transform hover:scale-105"
                            >
                                <MdEdit size={20} />
                                <span>{translations[language]?.edit || 'Edit'}</span>
                            </button>
                        )}
                        <button
                            onClick={handlePrint}
                            className="flex items-center space-x-2 px-6 py-3 bg-green-600 text-white rounded-xl hover:bg-green-700 transition-all shadow-md transform hover:scale-105"
                        >
                            <MdPrint size={20} />
                            <span>{translations[language]?.Print || 'Print'}</span>
                        </button>
                    </div>
                </div>

                {/* Single Certificate Content */}
                <div className="p-6">
                    <div
                        ref={certificateContentRef}
                        id="certificate-content"
                        className="space-y-4 bg-white shadow-lg rounded-lg border border-gray-300"
                        style={{ fontFamily: "'Noto Sans Devanagari', Arial, sans-serif", minHeight: '297mm', maxWidth: '210mm', padding: '15mm', margin: '0 auto' }}
                    >
                        {/* Header */}
                        <div className="text-center mb-6">
                            <img src="/Emblem_of_India.svg" alt="Emblem" style={{ width: "60px", margin: "0 auto 10px" }} />
                            <div className="font-bold text-lg">महाराष्ट्र शासन</div>
                            <div className="font-bold text-lg">महसूल व वन विभाग</div>
                            <div className="font-bold text-xl mt-2">{formData.section_11_office_name}</div>
                            <div className="font-medium text-base">शाखा :- {formData.section_11_branch_name}</div>
                            <div className="font-bold text-xl mt-2">{formData.section_11_address}</div>
                            <div className="text-sm">{formData.address}</div>
                        </div>

                        {/* Contact File Using the New API State */}
                        <div className="text-sm mb-4 contact-file">
                            <div className="flex justify-between font-semibold top">
                                <div>ई-मेल :- {formData.section_11_email || '---'}</div>
                                <div>दूरध्वनी क्रमांक :- {formData.section_11_mobile_no || '---'}</div>
                            </div>
                            <div className="flex justify-between mt-1 border-t-2 border-black pt-1 font-semibold bottom">
                                <div>{formData.certificate_no || '---'}</div>
                                <div>दिनांक:- {formatDate(formData.certificate_date)}</div>
                            </div>
                        </div>

                        {/* Editable Dynamic Paragraph */}
                        <div className="text-justify leading-relaxed space-y-4">
                            <p className="indent-8 whitespace-pre-wrap">{displayParagraph}</p>
                        </div>

                        {/* Single Unified Land Details Table - Grouped by Village */}
                        <div className="mt-8 flex justify-center">
                            <div className="w-full">
                                <div className="text-center font-bold underline mb-4 text-lg">
                                    *संपादीत जमिनीचा तपशील*
                                </div>
                                <table className="border-2 border-black text-center w-full">
                                    <thead>
                                        <tr className="bg-gray-100">
                                            <th className="border-2 border-black p-3 font-bold">गावाचे नाव</th>
                                            <th className="border-2 border-black p-3 font-bold">गट क्रमांक</th>
                                            <th className="border-2 border-black p-3 font-bold">लागवडयोग्य क्षेत्र<br />(हे.आर)</th>
                                            <th className="border-2 border-black p-3 font-bold">पोटखराब क्षेत्र<br />(हे.आर)</th>
                                            <th className="border-2 border-black p-3 font-bold">एकूण संपादीत क्षेत्र<br />(हे.आर)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.entries(groupedLandData).map(([village, records], vIndex) => (
                                            <React.Fragment key={`village-${vIndex}`}>
                                                {records.map((record, rIndex) => (
                                                    <tr key={record.id || `${vIndex}-${rIndex}`}>
                                                        {rIndex === 0 && (
                                                            <td 
                                                                className="border-2 border-black p-3 font-bold align-middle" 
                                                                rowSpan={records.length}
                                                            >
                                                                {village}
                                                            </td>
                                                        )}
                                                        <td className="border-2 border-black p-3">{record.gat_no}</td>
                                                        <td className="border-2 border-black p-3">{record.irrigable_area}</td>
                                                        <td className="border-2 border-black p-3">{record.non_irrigable_area}</td>
                                                        <td className="border-2 border-black p-3">{record.total_area}</td>
                                                    </tr>
                                                ))}
                                            </React.Fragment>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="mt-8">
                            <p>करीता सदर प्रमाणपत्र देण्यात येत आहे.</p>
                        </div>

                        {/* Signature Section */}
                        <div className="mt-16 flex justify-between signature-section">
                            <div>
                                <div>ठिकाण :- बुलढाणा</div>
                            </div>
                            <div className="text-center">
                                <div className="mt-12">
                                    <div>({laoName || '------------------'})</div>
                                    <div>{laoDesi || 'भूसंपादन अधिकारी'}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Modal Hooked Up To KJPTabapavti Columns */}
            {isEditing && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-xl overflow-hidden max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                        <div className="p-8">
                            <div className="flex justify-between items-center mb-6">
                                <h2 className="text-2xl font-bold text-gray-800">भुसंपादन प्रमाणपत्र संपादित करा</h2>
                                <button onClick={() => setIsEditing(false)} className="text-gray-500 hover:text-gray-700 text-2xl font-bold">
                                    <MdClose size={28} />
                                </button>
                            </div>

                            <form onSubmit={handleSubmit}>
                                <div className="mb-6">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        
                                        <div className="md:col-span-2 mb-4">
                                            <label className="block font-semibold text-gray-700 mb-2">मुख्य मजकूर (Main Paragraph):</label>
                                            <textarea
                                                rows="5"
                                                name="certificate_default_content"
                                                value={formData.certificate_default_content || displayParagraph}
                                                onChange={handleInputChange}
                                                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            />
                                        </div>

                                        <div>
                                            <label className="block font-semibold text-gray-700 mb-2">अधिसूचना क्रमांक (Certificate No):</label>
                                            <input
                                                type="text"
                                                name="certificate_no"
                                                value={formData.certificate_no}
                                                onChange={handleInputChange}
                                                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            />
                                        </div>

                                        <div>
                                            <label className="block font-semibold text-gray-700 mb-2">दिनांक (Certificate Date):</label>
                                            <input
                                                type="date"
                                                name="certificate_date"
                                                value={formatDateForInput(formData.certificate_date)}
                                                onChange={handleInputChange}
                                                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="flex justify-end gap-4 pt-6 border-t border-gray-200">
                                    <button
                                        type="button"
                                        onClick={() => setIsEditing(false)}
                                        className="px-6 py-3 border-2 border-gray-300 text-gray-700 font-semibold rounded-xl hover:bg-gray-50"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        disabled={loading}
                                        className="flex items-center gap-2 px-8 py-3 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 disabled:opacity-50"
                                    >
                                        {loading && <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>}
                                        <span>{loading ? 'Saving...' : 'Save'}</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LandAcquisitionCerti;